import React, { Suspense, lazy, useState, useMemo } from 'react';

import Modal from 'react-modal';

import AdaptiveImage from '@/components/Elements/AdaptiveImage/AdaptiveImage';

import { IImage } from '@/types/types';

import OpenIcon from '@/icons/open-icon.svg';

import './ImageZoom.scss';

const FullImage = lazy(() => import('./FullImage'));

type Props = {
  image: IImage;
  alt: string;
  customClass?: string;
};

export const ImageZoom = ({ image, alt, customClass }: Props) => {
  const [modalIsOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const modalSettings = useMemo(
    () => ({
      isOpen: modalIsOpen,
      onRequestClose: closeModal,
      overlayClassName: 'ImageZoom_container',
      className: 'ImageZoom_modal-content',
      bodyOpenClassName: 'ImageZoom_modal-opened',
      ariaHideApp: false,
      shouldCloseOnOverlayClick: true,
      preventScroll: true,
    }),
    [modalIsOpen],
  );

  const fileStorageUrl: string | undefined = process.env.IMAGE_STORAGE_PATH;
  const fallbackImageFileName: string = image.hash + image.ext;
  const fullImg = `${fileStorageUrl}${fallbackImageFileName}`;

  return (
    <div className="ImageZoom">
      <div className="ImageZoom_popup-preview" onClick={() => openModal()}>
        <OpenIcon />
        <AdaptiveImage image={image} objectFit="cover" objectPosition="50% 50%" alt={alt} className={customClass} />
      </div>
      <Modal {...modalSettings}>
        <Suspense>
          <FullImage onChange={closeModal} fullImg={fullImg} alt={alt} />
        </Suspense>
      </Modal>
    </div>
  );
};
